import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { ExcelExportService } from 'src/app/Services/excel.service';

@Component({
  selector: 'app-view-branch',
  templateUrl: './view-branch.component.html',
  styleUrls: ['./view-branch.component.css']
})
export class ViewBranchComponent implements OnInit {
  public branchInformation = [];
  public searchInput: any = new Subject<string>();
  searchedValue: any = '';
  serchKey = 'branchName'
  noDataEnable: boolean = false;
  public excelData:any = {};
  constructor(
    public api: ApiService,
    public storage: StorageService,
    public router: Router,
     public comservice:CommonServices,  
     public excel: ExcelExportService,
    public swal: SweetAlert) { }

  ngOnInit(): void {
    this.getBranchList();
  }
  getBranchList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.branchInformation = res.data;
        this.noDataEnable = true
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  editBranchData(data){
    this.router.navigate(['/organization/transport-manager/information/orgInfo/branch/edit-branch', data.branchID ]);
  }
  getBranchNameById(branchId: string): string | null {
  const branch: any = this.branchInformation.find((item: any) => item.branchID === branchId);
  return branch ? branch.branchName : null;
}
capitalizeFirstLetter(value: string): string {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
  async downloadExcel() {
    let branchData:any =await this.getBranch_ExlData().catch((e)=>{ console.log('error',e)});

    setTimeout(() => {
      this.exportToExcel(branchData);
    }, 2000);
    
  }   

getBranch_ExlData(){
      //getTrackingData
      return new Promise(async (resolve, reject) => {
        let obj = {
         // page:0,
          //limit:100
        }
        let returnData:any = [];
          let res :any = await this.api.transportManagerBranchExcelDownload(obj).catch((e) => { console.log("Get tracking data"); });
           if (res && res['status'] == 'success') {
             
              returnData = [...returnData, ...res['data']];
            }

        resolve(returnData);
      })
    }



  async exportToExcel(branchData:any) {
      let headers:any = [];
      let data:any = [];
      this.excelData = {};
      let finalColumn = 'E2';
      //  console.log('list action sos data',this.listActionSosData);
      //'Work Location',
      headers = [
        'S.No.',
        'Branch Name',
        'Location Name',
        'Is Nodal Branch',
        'Radius',
        
      ];
      for(let i=0;i<branchData.length;i++){
        let item = branchData[i];
       

        let empItem = [
          i+1,
          item.branchName?this.capitalizeFirstLetter(item.branchName):'---',
          item.location?this.capitalizeFirstLetter(item.location.name):'---',
          item.isNodal && item.isNodal === true ? 'Yes' : 'No',
          item.radius ? item.radius + ' km' : '---',
             
        ]
        data.push(empItem);
      }

      const excelInfo = {
        title: {
          title: `Branch Details`,
          font: { name: 'Corbel', family: 4, size: 16, underline: 'double', bold: true, color: { argb: 'FFFFFFFF' } },
          mergeCells: `A1:${finalColumn}`,
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF5F5BC5' },
            bgColor: { argb: 'FF5F5BC5' }
          }
        },
        header: {
          headers: headers,
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFF00' },
            bgColor: { argb: 'FF0000FF' }
            // fgColor: { argb: 'FF5F5BC5' },
            // bgColor: { argb: 'FF5F5BC5' }
          },
          // font: { bold: true, color: { argb: 'FFFFFFFF' } },
          border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
        },
        data: {
          data: data,
          columWith: [
            { colNo: 1, width: 7 },
            { colNo: 2, width: 20 },
            { colNo: 3, width: 80 },
            { colNo: 4, width: 20 },
            { colNo: 5, width: 25 },
           
          ]
        }
      };
      // console.log('excel information', excelInfo);
      if (this.excelData['Branch_Details'] == undefined) { this.excelData['Branch_Details'] = {}; }
      this.swal.swalFunction("Success","Success","Please check your downloads", 2000);
  
      this.excelData['Branch_Details'] = excelInfo;
  
      const chunk: any = await this.comservice.chunkObject(this.excelData, 50);
      for (let i = 0; i < chunk.length; i++) {
        this.excel.generateExcel(chunk[i], 'Branch_Details' + this.comservice.timestampToDate(new Date().getTime(),'DMY_H_M_S') + '.xlsx');
      }
      
     
  
      //this.excel.generateExcel(this.listActionSosData, `SOS_${this.activeTable}_` + new Date().getTime() + '.xlsx');
    }
}
